import { useState, useEffect } from "react";
import TransactionCard from "./TransactionCard";
import { GetPaymentList } from "../../services/api";

const tabs = ["ALL", "PENDING", "SUCCESS", "FAILED"];

export default function TransactionHistory() {
    const [activeTab, setActiveTab] = useState("ALL");
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);

    useEffect(() => {
        setPage(1);
        fetchTransactions(1, activeTab);
    }, [activeTab]);

    const fetchTransactions = async (pageNumber, status = activeTab) => {
        if (pageNumber === 1) setLoading(true);
        else setLoadingMore(true);

        try {
            const res = await GetPaymentList(pageNumber, 20, status);
            if (res?.data?.data) {
                const mappedData = res.data.data.map(item => ({
                    id: item._id,
                    title: "Buy Coins",
                    amount: item.finalPrice,
                    coins: item.coins,
                    utr: item.gatewayPaymentUtr || item.gatewayPaymentId || "N/A",
                    status: item.status?.toUpperCase() || "UNKNOWN",
                    createdAt: new Date(item.createdAt).toLocaleString('en-US', {
                        day: '2-digit', month: 'short', year: 'numeric',
                        hour: '2-digit', minute: '2-digit', hour12: true
                    }).replace(',', ' •')
                }));
                
                if (pageNumber === 1) {
                    setTransactions(mappedData);
                } else {
                    setTransactions(prev => [...prev, ...mappedData]);
                }
                
                if (res.data?.pagination) {
                    setHasMore(res.data.pagination.hasNext);
                } else {
                    setHasMore(false);
                }
            }
        } catch (error) {
            console.error("Failed to fetch payment list", error);
        } finally {
            setLoading(false);
            setLoadingMore(false);
        }
    };

    const handleLoadMore = () => {
        if (!loadingMore && hasMore) {
            const nextPage = page + 1;
            setPage(nextPage);
            fetchTransactions(nextPage, activeTab);
        }
    };

    const filtered = transactions;

    return (
        <div className="min-h-screen bg-black text-white pt-[50px] pb-20 mt-16">
            <div className="max-w-md mx-auto px-4">

                {/* Tabs */}
                <div className="flex gap-2 mb-4 overflow-x-auto no-scrollbar pb-1">
                    {tabs.map((tab) => (
                        <button
                            key={tab}
                            onClick={() => {
                                setActiveTab(tab);
                            }}
                            className={`flex-1 py-2 rounded-full text-sm font-medium whitespace-nowrap px-4
                                    ${activeTab === tab
                                    ? "bg-red-500"
                                    : "bg-[#1f1f1f] text-gray-400"
                                }`}
                        >
                            {tab}
                        </button>
                    ))}
                </div>

                {/* List */}
                <div className="space-y-3">
                    {loading ? (
                        <div className="text-center text-gray-400 mt-20 p-4">Loading transactions...</div>
                    ) : filtered.length === 0 ? (
                        <EmptyState />
                    ) : (
                        <>
                            {filtered.map((txn) => (
                                <TransactionCard key={txn.id} txn={txn} />
                            ))}
                            {hasMore && (
                                <div className="text-center pt-4 pb-8">
                                    <button 
                                        onClick={handleLoadMore}
                                        disabled={loadingMore}
                                        className="bg-[#1f1f1f] hover:bg-[#2a2a2a] text-white px-6 py-2 rounded-full font-medium transition disabled:opacity-50"
                                    >
                                        {loadingMore ? "Loading..." : "Load More"}
                                    </button>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

function EmptyState() {
    return (
        <div className="text-center text-gray-400 mt-20">
            <p>No transactions found</p>
        </div>
    );
}